import * as React from "react";
import styled from "styled-components";

export function SectionHeader() {
  return (
    <HeaderWrapper>
      <HeaderTitle>Subscribe</HeaderTitle>
      <HeaderDescription>
        <DesktopText>
          Get exclusive Direct Sales insights, event invites, and industry updates.
        </DesktopText>
        <MobileText>
          Subscribe to the newsletter!
        </MobileText>
      </HeaderDescription>
    </HeaderWrapper>
  );
}

const HeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  color: var(--Primary-White, #fff);
  font-weight: 400;
  justify-content: start;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const HeaderTitle = styled.h2`
  align-self: center;
  gap: 10px;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 3.11px;
  font: 16px Satoshi, sans-serif;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const HeaderDescription = styled.p`
  text-align: center;
  margin-top: 10px;
  font: 41px/50px Sora, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
  }
  
  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 1.2;
  }
`;

const DesktopText = styled.span`
  @media (max-width: 500px) {
    display: none;
  }
`;

const MobileText = styled.span`
  display: none;
  
  @media (max-width: 500px) {
    display: inline;
  }
`;